module.exports = __webpack_public_path__ + "static/media/builddoctor4.855fbb78.png";